// extracted by mini-css-extract-plugin
export default {"main":"Gem_main__MsI6t","title":"Gem_title__GHq4f","description":"Gem_description__9WA57"};